var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_3332","data-name":"Group 3332","transform":"translate(-1003.195 -520.379)"},React.createElement("path",{"id":"Path_556","data-name":"Path 556","d":"M1008.939,533.287h0a2.252,2.252,0,0,1-1.592-.659l-4.968-4.968,1.125-1.125,4.639,4.639V516.379h1.592v14.794l4.639-4.639,1.125,1.125-4.968,4.968A2.252,2.252,0,0,1,1008.939,533.287Z","transform":"translate(0.816 4)","fill":"#f40"})));
}

DownArrow.defaultProps = {"width":"13.121","height":"16.908","viewBox":"0 0 13.121 16.908"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
